import { ref } from "vue"

export interface Notification {
  id: number
  type: "success" | "error" | "warning" | "notice"
  message: string
  duration?: number
}

const notifications = ref<Notification[]>([])
let nextId = 0

export function useNotifications() {
  const addNotification = (type: Notification["type"], message: string, duration = 5000) => {
    const id = nextId++
    notifications.value.push({ id, type, message, duration })
    return id
  }

  const removeNotification = (id: number) => {
    const index = notifications.value.findIndex((n) => n.id === id)
    if (index > -1) notifications.value.splice(index, 1)
  }

  const clearAll = () => {
    notifications.value = []
  }

  const success = (message: string, duration?: number) => addNotification("success", message, duration)
  const error = (message: string, duration?: number) => addNotification("error", message, duration)
  const warning = (message: string, duration?: number) => addNotification("warning", message, duration)
  const notice = (message: string, duration?: number) => addNotification("notice", message, duration)

  return { notifications, addNotification, removeNotification, clearAll, success, error, warning, notice }
}
